<form [formGroup]="form">
  <file360-multi-line-text-field elementId="keywords" label="Keywords" placeholder="Add new keywords"
    formControlName="keywords" [maxRows]="15" [minRows]="15">
  </file360-multi-line-text-field>
</form>